import "./list"
import "./recipes"
import BCheckpanel from "../modules/BCheckpanel"
import BDatepicker from "./modules/BDatepicker"
import BInput from "../modules/BInput"
import BProfileSetupProductForm from "../modules/BProfileSetupProductForm"
import BRecaptchaForm from "../modules/BRecaptchaForm"
import BSelect from "./modules/BSelect"
import BShowtoggle from "../modules/BShowtoggle"
import MChart from "./modules/MChart"
import MDiaryDay from "./profile/MDiaryDay"
import MDrugs from "./profile/MDrugs"
import MDrugsForm from "./profile/MDrugsForm"
import MFrontCaloricCalculator from "../modules/CaloricCalculator/MFrontCaloricCalculator"
import MMeasurements from "./profile/MMeasurements"
import MMeasurementsForm from "./profile/MMeasurementsForm"
import MModalTrigger from "../modules/MModalTrigger"
import MTabs from "../modules/MTabs"
import MDiaryDayEntry from "./profile/MDiaryDayEntry"
import MDiaryDayEntries from "./profile/MDiaryDayEntries"

BCheckpanel.addEventListeners();
BDatepicker.initialize();
BInput.initialize();
BProfileSetupProductForm.addEventListeners();
BRecaptchaForm.addEventListeners();
BSelect.initialize();
BShowtoggle.initialize();
MChart.initialize();
MDiaryDay.initialize();
MDiaryDayEntries.addEventListeners();
MDiaryDayEntry.addEventListeners();
MDrugs.addEventListeners();
MDrugsForm.addEventListeners();
MDrugsForm.initialize();
MFrontCaloricCalculator.initialize();
MMeasurements.addEventListeners();
MMeasurementsForm.addEventListeners();
MModalTrigger.initialize();
MTabs.initialize();

try {
	document.querySelector(`.focus`).focus();
} catch (error) {
	// Nevermind.
}
